import React, { useEffect } from 'react';
import './CustomAlert.scss';
import Confirm from '../../../images/confirm.svg';
import Error from '../../../images/error.svg';
import Warning from '../../../images/warning.svg';
import Exclamation from '../../../images/confirm-image.svg';
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Divider, IconButton, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { countryList } from "../../../constants/countrylist";
import {stateData} from "../../../constants/countrylist";

const CustomAlert = ({ 
    severity, 
    show, 
    header, 
    message, 
    onClick, 
    type, 
    alertType,
    handleSMSEmail,
    additionalInformation,
    confirmButton,
    autoclose = true,
    confirmButtonText,
    cancelButtonText,
  }) => {

  const [infoMessage, setInfoMessage] = useState("");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timer;
    if (show && autoclose && severity !== "confirm") { 
      setProgress(0);
      timer = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(timer);
            onClick(); 
            return 100;
          }
          return prev + 2; 
        });
      }, 100);
    }
    return () => clearInterval(timer);
  }, [show, onClick, autoclose]);


  useEffect(() => {
    setInfoMessage("");
  }, [show]);

  if (!show) {return null;}
  const iconMapping = {
    success: Confirm,
    error: Error,
    warning: Warning,
    confirm: Exclamation
  };

  const className = severity === 'success' ? 'congratulations-message' : severity === 'error' ?  'error-message' : 'warning-message';

  const IconComponent = iconMapping[severity] || Error;

  const handleContainerClick = (e) => {
    e.stopPropagation();
  };


  return (
    <Box className="success-box-overlay" onClick={onClick}>
      <Box className="success-box-container" onClick={handleContainerClick}>
        {
          severity !== "confirm" 
          &&
          <>
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
              }}
            >
              <CircularProgress
                variant="determinate"
                value={progress}
                size={40}
                thickness={4}
                sx={{
                  position: "absolute",
                  color: "#6c757d",
                }}
              />
              <IconButton
                onClick={() => {
                  setProgress(0);
                  onClick();
                }}
                sx={{
                  zIndex: 1,
                  color: "#6c757d",
                  "&:hover": {
                    color: "#000",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <img src={IconComponent} alt={type} className="success-icon" loading="lazy" />
            <Box className={className}>{header}</Box>
            <Box className="transfer-completed-message" dangerouslySetInnerHTML={{ __html: message?.replace(/\n/g, '<br />') }}></Box>
          </>
        }

        {
          severity === "confirm" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <img
                  src={IconComponent} // Exclamation icon for confirm
                  alt={type}
                  style={{
                    width: "40px", // Adjust the size to match the design
                    height: "40px",
                  }}
                />
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "20px", // Matches the header text size
                    color: "#003366", // Navy color from the screenshot
                    fontFamily: "Nunito",
                  }}
                >
                  Please Confirm
                </Box>
              </Box>
            </>
          )
        }

        {
          additionalInformation && (
            <>
              <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "100%" }} />
              <Box sx={{ fontFamily: "Nunito", display: "grid", gridTemplateColumns: "2fr 2fr", gap: 1 }}>
                {Object.entries(additionalInformation).map(([key, value]) => (
                  <React.Fragment key={key}>
                    <Box sx={{ fontWeight: "bold", textAlign: "right", paddingRight: 2 }}>{key}</Box>
                    {key.toLowerCase().includes("Country".toLowerCase()) ? 
                      <Box sx={{ textAlign: "left" }}>
                        {countryList.filter((country) => country.value === value)[0]?.label}
                      </Box>
                      :
                      key.toLowerCase().includes("state".toLowerCase()) ? 
                      <Box sx={{ textAlign: "left" }}>
                        {stateData.filter((country) => country.iso3 === additionalInformation['Country'])[0]?.states?.filter((state) => state.state_code === value)[0]?.name}
                      </Box>
                      :
                      <Box sx={{ textAlign: "left" }}>{value}</Box>
                    }
                  </React.Fragment>
                ))}
              </Box>
            </>
          )
        }


        {alertType === "localtransfer" && (
          <>
            <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "100%" }} />
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, marginTop: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <Button variant="contained" color="primary" onClick={() => handleSMSEmail(0, setInfoMessage)}>
                  Send SMS
                </Button>
                <Button variant="contained" color="primary" onClick={() => handleSMSEmail(1, setInfoMessage)}>
                  Send Email
                </Button>
              </Box>
              {infoMessage && (
                <Box className="info-message" sx={{ marginTop: 1 }}>
                  {infoMessage}
                </Box>
              )}
            </Box>
          </>
        )}

        {
          alertType === "confirm" && (
            <>
              <Divider sx={{ my: 2, border: "1px solid #A6A6A6", width: "100%" }} />
              <Box className="alert-message-container" sx={{ fontWeight: "bold", textAlign: "right", paddingRight: 2 }}>{message}</Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  marginTop: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#28a745", // Green color
                    color: "white",
                    textTransform: "none", // Keep the text casing as-is
                    fontWeight: "bold",
                    fontFamily: "Nunito",
                    "&:hover": {
                      backgroundColor: "#218838", // Slightly darker green
                    },
                  }}
                  onClick={() => {confirmButton(); onClick()}}
                >
                  {confirmButtonText ? confirmButtonText : "YES, CONFIRM!"}
                </Button>

                {/* Cancel Button */}
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#dc3545", // Red color
                    color: "white",
                    textTransform: "none", // Keep the text casing as-is
                    fontWeight: "bold",
                    fontFamily: "Nunito",
                    "&:hover": {
                      backgroundColor: "#c82333", // Slightly darker red
                    },
                  }}
                  onClick={onClick} // Close alert or perform cancel action
                >
                  {cancelButtonText ? cancelButtonText : "CANCEL"}
                </Button>
              </Box>
            </>
          )
        }

      </Box>
    </Box>
  );
};

export default CustomAlert;
